import CityPageTemplate from "../city-template/CityPageTemplate";
import { beavercreekConfig } from "./data";

export default function BeavercreekPage() {
  return <CityPageTemplate config={beavercreekConfig} />;
}